export enum HomeOwnershipType {
  RENTAL = "RENTAL",
  OWN = "OWN",
}

export interface EuerDeclarationOfficeUsageSubformFlatRate5EurInputs {
  daysUsed: number;
}

export interface EuerDeclarationOfficeUsageSubformBaseInputs {
  totalHomeArea: number;
  officeArea: number;
  usageStartedAt?: string;
  monthsUsed: number;
  usagePeriodOperatingHomeExpenses: number;
  annualOtherHomeExpenses: number;
  annualOtherOfficeExpenses: number;
  paidHomeExpensesInputTax16: number;
  paidHomeExpensesInputTax19: number;
  paidOfficeExpensesInputTax16: number;
  paidOfficeExpensesInputTax19: number;
}

export interface EuerDeclarationOfficeUsageSubformFullCostRentalHomeInputs
  extends EuerDeclarationOfficeUsageSubformBaseInputs {
  homeOwnershipType: HomeOwnershipType.RENTAL;
  monthlyRent: number;
}

export interface EuerDeclarationOfficeUsageSubformFullCostOwnHomeInputs
  extends EuerDeclarationOfficeUsageSubformBaseInputs {
  homeOwnershipType: HomeOwnershipType.OWN;
  annualHomeDepreciation: number;
}

export type EuerDeclarationOfficeUsageSubformFullCostInputs =
  | EuerDeclarationOfficeUsageSubformFullCostRentalHomeInputs
  | EuerDeclarationOfficeUsageSubformFullCostOwnHomeInputs;

export type EuerDeclarationOfficeUsageSubformUpTo1250EurInputs =
  EuerDeclarationOfficeUsageSubformFullCostInputs;

export type EuerDeclarationOfficeUsageSubformInputs =
  | EuerDeclarationOfficeUsageSubformFlatRate5EurInputs
  | EuerDeclarationOfficeUsageSubformFullCostInputs
  | EuerDeclarationOfficeUsageSubformUpTo1250EurInputs;

export interface EuerDeclarationOfficeUsageSubformCalculationResults {
  homeOfficeExpenses: number; // [172] Abziehbare Aufwendung für häusliches Arbeitszimmer (inkl. AfA und Schuldzinsen)
  // `paidInputTax` is only applicable to the OFFICE_USAGE_FULL_COST and OFFICE_USAGE_UP_TO_1250_EUR calculation methods.
  paidInputTax?: number; // [185] Gezahlte Vorsteuerbeträge
  profitReduction: number; // Gewinnminderung
}

export enum HomeOfficeExpensePeriod {
  ANNUAL = "ANNUAL",
  MONTHLY = "MONTHLY",
  ONE_TIME_PAYMENT = "ONE_TIME_PAYMENT",
}
